import React from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import FooterConditions from './FooterConditions'
import FooterPerks from './FooterPerks'

interface ReferralProgramFooterProps {
  isoCountryCode: string
}

const ReferralProgramFooter: React.FC<ReferralProgramFooterProps> = ({ isoCountryCode }) => {
  const { isMobile } = useBreakpoint()
  const { canRequestUpsell } = useCurrentSession()
  return (
    <>
      <Box
        flexDirection={isMobile ? 'column' : 'row'}
        gap="s32"
        width="full"
        minHeight="s300"
        paddingTop={isMobile ? 's0' : 's32'}
        paddingBottom="s80"
        justifyContent="center"
      >
        <Box
          flexDirection={isMobile ? 'column' : 'row'}
          style={{
            maxWidth: '1200px',
          }}
          width="full"
          gap="s32"
          justifyContent="center"
        >
          <FooterConditions />
          {canRequestUpsell && <FooterPerks isoCountryCode={isoCountryCode} />}
        </Box>
      </Box>
    </>
  )
}

export default ReferralProgramFooter
